import events from 'packages/alcumus-local-events'

import { signOut } from 'utils/authenticationService'
import { getItem, getUnprefixedItemAndParse, setUnprefixedItemWithStringify } from 'common/using-local-storage-key'
import { getCurrentAuthenticatedUser } from 'common/global-store/api'

const MILLISECONDS = 1000
const MINUTES_IN_MILLISECONDS = 60 * MILLISECONDS
const SESSION_LENGTH_IN_MILLISECONDS = 120 * MINUTES_IN_MILLISECONDS // 120 min
const DELAY_IN_MILLISECONDS = 2 * MINUTES_IN_MILLISECONDS // 2 min
const MAX_TIMEOUT = SESSION_LENGTH_IN_MILLISECONDS + DELAY_IN_MILLISECONDS // 121 min

let timer = 0
let interactionTimer = 0

export async function performLogout() {
    const timeout = getUnprefixedItemAndParse('lastInteraction')
    if (timeout > Date.now()) {
        setTimeout(performLogout, timeout - Date.now())
        return
    }
    if (getCurrentAuthenticatedUser()?.isAnonymous) return
    if (getItem('launcherApp')) {
        return await signOut('/')
    } else if (!window.location.pathname.startsWith('/login')) {
        sessionStorage.setItem('intendedDest', window.location.href)
        return await signOut('/login')
    } else {
        return await signOut()
    }
}

export function startTimeout() {
    clearTimeout(timer)
    setUnprefixedItemWithStringify('lastInteraction', SESSION_LENGTH_IN_MILLISECONDS + Date.now())
    timer = setTimeout(performLogout, MAX_TIMEOUT)
}

function startInteractionTimeout() {
    clearTimeout(interactionTimer)
    setUnprefixedItemWithStringify('lastInteraction', SESSION_LENGTH_IN_MILLISECONDS + Date.now())
    interactionTimer = setTimeout(performLogout, MAX_TIMEOUT)
}

document.body.addEventListener('click', startInteractionTimeout)
document.body.addEventListener('keypress', startInteractionTimeout)

events.on('sign-in-event', startTimeout)
